import { render, staticRenderFns } from "./EmployeeTypeForm.vue?vue&type=template&id=0bba3c85"
import script from "./EmployeeTypeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports